import store from '../store'
import { getFakeUser } from './fakeUser'

async function realAuth(from, to, next) {
	var authRequired = to.matched.some(e => e.meta.authRequired)
	console.log("AUTH REQUIRED")
	// okay, if required and we're not logged in yet (check user info)
	console.log(store.state.userInfo)
	if (authRequired /* && !store.state.userInfo */) {
		store.commit('setBusyState', true)
		// force reattachment if we're not attached
		const sso = store.getters.sso
		console.log(`AWAIT_CHECK_SSO`)

		var tries = 0
		while (!sso.attached) {
			// await sso.spinWait(30)
			++tries
			console.log(`ATTACH_ON_AUTH, tries : ${tries}`)
			await sso.attach()
		}
		// if still failed, return to forbidden?
		if (!sso.attached) {
			console.log(`CRITICAL_FAILUER: SSO_ATTACH!`)
			next('/forbidden')
		} else {
			console.log(`SSO_ATTACHED, token is : ${sso.bearerToken}`)
			// store to vuex and set api
			store.commit('setToken', sso.bearerToken)
			store.getters.api.setToken(sso.bearerToken)
			// we're attached, check if we can get user info...
			try {
				var userInfo = await sso.getUserInfo()

				console.log(`AUTH_USER_INFO_RETURNED: `, userInfo)

				store.commit('setBusyState', false)
				// gotta check if we have user info
				if (userInfo.data) {
					// we succeed, store and return
					console.log('AUTH_USER_INFO_VALID')
					store.commit('setUserInfo', userInfo.data)

					// do we have roles in this app?
					if (store.getters.roles) {
						console.log('AUTH_USER_INFO_AUTHORIZED')
						next()
					} else {
						// a valid user data, but unauthorized
						console.log('AUTH_USER_INFO_UNAUTHORIZED')
						next('/forbidden')
					}
				} else {
					// gotta go login, cause we aint got data
					console.log('AUTH_USER_INFO_EMPTY...LOGIN AGAIN')
					next('/login')
				}


			} catch (error) {
				console.log(`AUTH_ERROR_GET_USER_INFO: `, error.message)
				console.log(`Code: ${error.code}, Message: ${error.message}`)

				// depending on if it's caused by not attached exception,
				// do something
				// by default we assume the broker is de-attached
				sso.attached = false

				store.commit('setBusyState', false)
				next('/login')
			}
		}
	} else {
		store.commit('setBusyState', false)
		next()
	}
}

async function fakeAuth(from, to, next) {
	console.log("Not in production. Bypassing login and authentication and using default user")

	var tokenDemo = process.env.MOCK_TOKEN || 'token_admin'
	var userDemo = getFakeUser(tokenDemo)

	// store dummy token
	store.getters.api.setToken(tokenDemo)
	// store default data
	store.commit('setUserInfo', userDemo)

	console.log(`Continuing using token: ${tokenDemo}`)
	console.log(`With Fake User: `, userDemo)
	next()

}

export {
	fakeAuth,
	realAuth
}



// WEBPACK FOOTER //
// ./src/router/authHandler.js